/* eslint-disable camelcase */
import React, { useState, useEffect, useRef, useMemo, forwardRef, useImperativeHandle } from "react";
import "./FlightsForm.css";
import { Accordion, Col, Row, Form } from "react-bootstrap";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { SingleCalendar } from "../../../../components";
import SignatureCanvas from "react-signature-canvas";
import { ReactComponent as UploadIcon } from "../../../../assets/images/icons/solar_upload-line-duotone.svg";
import axios from "axios";
import debounce from "lodash.debounce";
import TravelerSelector from "../../../../components/TravelerSelector/TravelerSelector";
import { useTranslation } from '../../../../contexts/TranslationContext';
import Cookies from "js-cookie";
import { axiosGet } from "../../../../utils/apis/api";



const FlightsForm = forwardRef(({ 
  onChange = () => {}, 
  showErrors = false, 
  initialData = null,
  flightFirstAdd = null ,
  selectedDates,
  url
}, ref) => {
  const [previewImage, setPreviewImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();
  const Lang = Cookies.get("preferred_language") || "en";
  const [activeAccordionKeys, setActiveAccordionKeys] = useState(['0']);
  const [infants, setInfants] = useState(0);

  const flightClassOptions = [
  { name: "Economy", label: t("Economy") },
  { name: "Business", label: t("Business") },
  { name: "First Class", label: t("FirstClass") },
];
const paymentMethodOptions = [
  { name: "Credit Card", label: t("CreditCard") },
  { name: "Tabby", label: t("Tabby") },
  { name: "Bank Transfer", label: t("BankTransfer") },
  { name: "Apple Pay", label: t("ApplePay") },
];
  // Field to accordion mapping
  const fieldToAccordionMap = {
    // Personal Information
    full_name: '0',
    date_of_birth: '0',
    gender: '0',
    nationality: '0',
    passport_number: '0',
    passport_issue: '0',
    passport_expiry: '0',
    phone: '0',

    // Flight Details
    destination_airport: '1',
    departure_date: '1',
    flight_class: '1',
    flexible_dates: '1',
    num_passengers: '1',
    
    // Payment & Billing
    payment_method: '2',
    billing_address: '2',
    invoice_required: '2',
    
    // Accommodation
    hotel_details: '3',
    
    // Documents
    file_passport_copy: '4',
    
    // Declaration
    agree_terms: '5',
    signature: '5'
  };

  const [form, setForm] = useState({
    full_name: "",
    date_of_birth: null,
    gender: "",
    nationality: "",
    passport_number: "",
    passport_issue: null,
    passport_expiry: null,
    phone: "",
    destination_airport: "",
    departure_date: flightFirstAdd ? new Date(flightFirstAdd.date_from) : null,
    return_date: flightFirstAdd ? new Date(flightFirstAdd.date_to) : null,
    preferred_airline: "",
    flight_class: null,
    flexible_dates: "",
    num_passengers_adults: 1,
    num_passengers_children: 0,
    ages: [],
    special_requests: "",
    hotel_booking: "0",
    hotel_details: "",
    payment_method: null,
    billing_address: "",
    invoice_required: "",
    files: {},
    agree_terms: false,
    signature: "",
  });

  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [childrenAges, setChildrenAges] = useState([]);
  const [errors, setErrors] = useState({});
  const inputRefs = useRef({});
  const sigPadRef = useRef();

  // Restore signature from initialData
  useEffect(() => {
    if (initialData?.signature && sigPadRef.current) {
      sigPadRef.current.fromDataURL(initialData.signature);
    }
  }, [initialData]);

  const PAGE_LIMIT = 20;

  // Nationality search
  const [natQuery, setNatQuery] = useState("");
  const [natOptions, setNatOptions] = useState([]);
  const [natLoading, setNatLoading] = useState(false);

  // const fetchNationalities = useMemo(() => debounce(async (q = "") => {
  //   try {
  //     setNatLoading(true);
  //     const params = q ? { search: q, limit: PAGE_LIMIT } : { limit: PAGE_LIMIT };
  //     const { data } = await axios.get(
  //       "https://crm.alltimestravels.com/api/method/alltimes.www.api.countries",
  //       { params }
  //     );
  //     setNatOptions(data.result.countries || []);
  //   } catch (e) {
  //     console.error(e);
  //   } finally {
  //     setNatLoading(false);
  //   }
  // }, 300), []);

  const fetchNationalities = useMemo(
    () =>
      debounce(async (q = "") => {
        try {
          setNatLoading(true);
          const params = q ? { search: q, limit: 20 } : { limit: 20 };
          const data = await axiosGet(
            "https://crm.alltimestravels.com/api/method/alltimes.www.api.countries",
            params
          );
          setNatOptions(data?.result?.countries || []);
        } catch (e) {
          console.error(e);
        } finally {
          setNatLoading(false);
        }
      }, 300),
    []
  );

  // Airline search
  const [airQuery, setAirQuery] = useState("");
  const [airOptions, setAirOptions] = useState([]);
  const [airLoading, setAirLoading] = useState(false);
  // const fetchAirlines = useMemo(() => debounce(async (q = "") => {
  //   try {
  //     setAirLoading(true);
  //     const params = q ? { search: q, limit: PAGE_LIMIT } : { limit: PAGE_LIMIT };
  //     const { data } = await axios.get(
  //       "https://crm.alltimestravels.com/api/method/alltimes.alltimes_travel.doctype.airline.airline.airline",
  //       { params }
  //     );
  //     setAirOptions(data.result.items || []);
  //   } catch (e) {
  //     console.error(e);
  //   } finally {
  //     setAirLoading(false);
  //   }
  // }, 300), []);

  const fetchAirlines = useMemo(
    () =>
      debounce(async (q = "") => {
        try {
          setAirLoading(true);
          const params = q ? { search: q, limit: PAGE_LIMIT } : { limit: PAGE_LIMIT };
          const data = await axiosGet(
            "https://crm.alltimestravels.com/api/method/alltimes.alltimes_travel.doctype.airline.airline.airline",
            params
          );
          setAirOptions(data?.result?.items || []);
        } catch (e) {
          console.error(e);
        } finally {
          setAirLoading(false);
        }
      }, 300),
    []
  )

  // Airport search
  const [airportQuery, setAirportQuery] = useState("");
  const [airportOptions, setAirportOptions] = useState([]);
  const [airportLoading, setAirportLoading] = useState(false);
  // const fetchAirports = useMemo(() => debounce(async (q = "") => {
  //   try {
  //     setAirportLoading(true);
  //     const params = q ? { search: q, limit: PAGE_LIMIT } : { limit: PAGE_LIMIT };
  //     const { data } = await axios.get(
  //       "https://crm.alltimestravels.com/api/method/alltimes.alltimes_travel.doctype.airport.airport.airport",
  //       { params }
  //     );
  //     setAirportOptions(data.result.items || []);
  //   } catch (e) {
  //     console.error(e);
  //   } finally {
  //     setAirportLoading(false);
  //   }
  // }, 300), []);

  const fetchAirports = useMemo(
  () =>
    debounce(async (q = "") => {
      try {
        setAirportLoading(true);
        const params = q ? { search: q, limit: PAGE_LIMIT } : { limit: PAGE_LIMIT };
        const data = await axiosGet(
          "https://crm.alltimestravels.com/api/method/alltimes.alltimes_travel.doctype.airport.airport.airport",
          params
        );
        setAirportOptions(data?.result?.items || []);
      } catch (e) {
        console.error(e);
      } finally {
        setAirportLoading(false);
      }
    }, 300),
  []
);

  // Fetch handlers
  useEffect(() => {
    fetchNationalities(natQuery);
    fetchAirlines(airQuery);
    fetchAirports(airportQuery);
  }, [natQuery, airQuery, airportQuery]);

  useEffect(() => {
    return () => {
      fetchNationalities.cancel();
      fetchAirlines.cancel();
      fetchAirports.cancel();
    };
  }, []);

  // Form validation
  const required = {
    full_name: t("FullNameRequired"),
    date_of_birth: t("DateOfBirthIsRequired"),
    gender: t("GenderIsRequired"),
    nationality: t("NationalityIsRequired"),
    passport_number: t("PassportNumberIsRequired"),
    passport_issue: t("PassportIssueRequired"),
    passport_expiry: t("PassportExpiryRequired"),
    phone: t("PhoneNumberIsRequired"),
    destination_airport: t("DestinationAirportRequired"),
    departure_date: t("DepartureDateRequired"),
    flight_class: t("FlightClassRequired"),
    flexible_dates: t("FlexibleDatesRequired"),
    payment_method:  t("PaymentMethodIsRequired"),
    billing_address: t("BillingAddressIsRequired"),
    invoice_required:  t("PleaseSpecifyIfInvoiceIsRequired"),
    agree_terms: t("YouMustAgreeToTheTerms"),
    signature: t("SignatureIsRequired"),
  };

  const requiredFiles = { passport_copy: t("PassportCopyIsRequired") };
  const rangeErr = {
    passport: t("PassportExpiryAfterIssue"),
    flight: t("ReturnAfterDeparture"),
  };

  const validate = () => {
    const errs = {};
    Object.entries(required).forEach(([k, msg]) => {
      if (!form[k] || (typeof form[k] === "string" && !form[k].trim())) errs[k] = msg;
    });
    
    Object.entries(requiredFiles).forEach(([k, msg]) => {
      if (!form.files[k]) errs[`file_${k}`] = msg;
    });

    if (form.phone) {
        const phoneRegex = /^\+?[0-9]{6,15}$/;
        if (!phoneRegex.test(form.phone))
          errs.phone = t("InvalidPhoneNumberFormat");
    }
    
    if (form.passport_issue && form.passport_expiry &&
        new Date(form.passport_issue) > new Date(form.passport_expiry)) {
      errs.passport_expiry = rangeErr.passport;
    }
    
    if (form.departure_date && form.return_date &&
        new Date(form.departure_date) > new Date(form.return_date)) {
      errs.return_date = rangeErr.flight;
    }
    
    if (form.hotel_booking === "1" && !form.hotel_details.trim()) {
      errs.hotel_details = t("HotelDetailsRequired");
    }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  useEffect(() => {
    onChange(form, validate());
    
  }, [form]);

  // Initial data setup
  useEffect(() => {
    if (!initialData) return;
    
    const toDate = (s) => (s ? new Date(s) : null);
    const newForm = {
      ...initialData,
      date_of_birth: toDate(initialData.date_of_birth),
      passport_issue: toDate(initialData.passport_issue),
      passport_expiry: toDate(initialData.passport_expiry),
      departure_date: initialData.departure_date ? new Date(initialData.departure_date) : null,
      return_date: initialData.return_date ? new Date(initialData.return_date) : null,
      hotel_booking: initialData.hotel_booking === "Yes" ? "1" : initialData.hotel_booking || "0",
      files: initialData.files || {},
    };
    
    setForm(newForm);
    setAdults(initialData.num_passengers_adults || 1);
    setChildren(initialData.num_passengers_children || (initialData.ages?.length || 0));
    setChildrenAges(initialData.ages || []);
    onChange(newForm, true);
  }, [initialData]);

  // Traveler count effect
  useEffect(() => {
    setForm(p => ({
      ...p,
      num_passengers: adults + children,
      num_passengers_adults: adults,
      num_passengers_children: children,
      ages: childrenAges,
    }));
  }, [adults, children, childrenAges]);

  // Auto-expand accordions with errors
  useEffect(() => {
    if (showErrors && Object.keys(errors).length > 0) {
      const errorAccordionKeys = Object.keys(errors)
        .map(field => fieldToAccordionMap[field])
        .filter(key => key !== undefined);
      
      setActiveAccordionKeys(prev => [
        ...prev,
        ...errorAccordionKeys.filter(key => !prev.includes(key))
      ]);
    }
  }, [showErrors, errors]);

  // Scroll to first error
  const scrollToFirstError = () => {
    const firstErrorKey = Object.keys(errors)[0];
    if (firstErrorKey) {
      const accordionKey = fieldToAccordionMap[firstErrorKey];
      if (accordionKey && !activeAccordionKeys.includes(accordionKey)) {
        setActiveAccordionKeys(prev => [...prev, accordionKey]);
      }

      setTimeout(() => {
        const element = document.getElementById(`field-${firstErrorKey}`);
        if (element) element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 300);
    }
  };

  useImperativeHandle(ref, () => ({
    scrollToFirstError,
    validate
  }));

  // Helper functions
  const Auto = ({ options, value, setValue, placeholder }) => (
    <Autocomplete
      fullWidth
      options={options}
      getOptionLabel={(o) => o.label}
      value={value ? options.find(o => o.name === value) : null}
      onChange={(_, v) => setValue(v?.name || null)}
      renderInput={(params) => (
        <TextField {...params} size="small" placeholder={placeholder || t("Select")} />
      )}
    />
  );

  const handleFileChange = (k, f) => {
    if (!f) return;
    setForm(p => ({ ...p, files: { ...p.files, [k]: f }}));
    if (inputRefs.current[k]) inputRefs.current[k].value = null;
  };

  const handleFileRemove = (k) => {
    setForm(p => {
      const files = { ...p.files };
      delete files[k];
      return { ...p, files };
    });
    if (inputRefs.current[k]) inputRefs.current[k].value = null;
  };

  const truncate = (text, max = 28) => 
    !text ? "" : text.length <= max ? text : `${text.slice(0, max - 6)}...${text.slice(-5)}`;
  
  const fileDisplayName = (file) => 
    typeof file === "string" ? file.split("/").pop() : file.name;
  
  const err = (field) => showErrors && errors[field];

  return (
    <Accordion
      alwaysOpen
      className="hotel-form-accordion services-flights-form-accordion-container"
      activeKey={activeAccordionKeys}
      onSelect={(keys) => setActiveAccordionKeys(keys)}
    >
      {/* 1. Personal Information */}
      <Accordion.Item eventKey="0" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          1. {t("PersonalInformation")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            {/* Full Name */}
            <Col xl={4} md={6}>
              <div className="hotel-form-input-container" id="field-full_name">
                <label className="hotel-form-input-label">
                  {t("FullName")} ({t("AsPerPassport")}) <span>*</span>
                </label>
                <input
                  className="hotel-form-input"
                  value={form.full_name}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, full_name: e.target.value }))
                  }
                  placeholder={t("FullName")}
                />
                {err("full_name") && (
                  <div className="field-error">{errors.full_name}</div>
                )}
              </div>
            </Col>

            {/* DOB */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-date_of_birth"
              >
                <label className="hotel-form-input-label">
                  {t("DateOfBirth")} <span>*</span>
                </label>
                <SingleCalendar
                  value={form.date_of_birth}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, date_of_birth: e.value }))
                  }
                  showTime={false}
                  placeholder={t("DateOfBirth")}
                />
                {err("date_of_birth") && (
                  <div className="field-error">{errors.date_of_birth}</div>
                )}
              </div>
            </Col>

            {/* Gender */}
            <Col xl={4} md={6}>
              <div className="hotel-form-input-container" id="field-gender">
                <label className="hotel-form-input-label">
                  {t("Gender")} <span>*</span>
                </label>
                <Form.Select
                  size="sm"
                  value={form.gender}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, gender: e.target.value }))
                  }
                  className="hotel-form-input select-dropdown"
                >
                  <option value="" disabled>
                    {t("SelectGender")}
                  </option>
                  <option value="Male">{t("Male")}</option>
                  <option value="Female">{t("Female")}</option>
                </Form.Select>
                {err("gender") && (
                  <div className="field-error">{errors.gender}</div>
                )}
              </div>
            </Col>

            {/* Nationality */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-nationality"
              >
                <label className="hotel-form-input-label">
                  {t("Nationality")} <span>*</span>
                </label>
                <Autocomplete
                  fullWidth
                  loading={natLoading}
                  options={natOptions}
                  getOptionLabel={(o) => o.name || ""}
                  value={
                    natOptions.find((o) => o.name === form.nationality) || null
                  }
                  inputValue={natQuery}
                  onInputChange={(_, v) => setNatQuery(v)}
                  onChange={(_, v) =>
                    setForm((p) => ({ ...p, nationality: v?.name || "" }))
                  }
                  sx={{
                    ".MuiAutocomplete-inputRoot": {
                      fontSize: "12px",
                      flexDirection: Lang === "ar" ? "row-reverse" : "row",
                    },
                    ".MuiAutocomplete-endAdornment": {
                      left: Lang === "ar" ? "9 !important" : "unset !important",
                      right:
                        Lang === "ar" ? "unset !important" : "9 !important",
                    },
                    ".MuiInputBase-input": {
                      textAlign: Lang === "ar" ? "right" : "left",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      placeholder={t("SelectNationality")}
                      InputProps={{
                        ...params.InputProps,
                        style: {
                          direction: Lang === "ar" ? "rtl" : "ltr",
                        },
                        sx: {
                          backgroundColor: "#FFF",
                          borderRadius: "6px",
                          padding: "9px 15px !important",
                          fontFamily: '"Dmsans400"',
                          fontSize: "14px !important",
                          fontWeight: 400,
                          letterSpacing: "0.25px",
                        },
                      }}
                    />
                  )}
                />
                {err("nationality") && (
                  <div className="field-error">{errors.nationality}</div>
                )}
              </div>
            </Col>

            {/* Passport Number */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-passport_number"
              >
                <label className="hotel-form-input-label">
                  {t("PassportNumber")} <span>*</span>
                </label>
                <input
                  className="hotel-form-input"
                  value={form.passport_number}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, passport_number: e.target.value }))
                  }
                  placeholder={t("PassportNumber")}
                />
                {err("passport_number") && (
                  <div className="field-error">{errors.passport_number}</div>
                )}
              </div>
            </Col>

            {/* Passport Issue */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-passport_issue"
              >
                <label className="hotel-form-input-label">
                  {t("PassportIssueDate")} <span>*</span>
                </label>
                <SingleCalendar
                  value={form.passport_issue}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, passport_issue: e.value }))
                  }
                  showTime={false}
                  placeholder={t("IssueDate")}
                />
                {err("passport_issue") && (
                  <div className="field-error">{errors.passport_issue}</div>
                )}
              </div>
            </Col>

            {/* Passport Expiry */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-passport_expiry"
              >
                <label className="hotel-form-input-label">
                  {t("PassportExpiryDate")} <span>*</span>
                </label>
                <SingleCalendar
                  value={form.passport_expiry}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, passport_expiry: e.value }))
                  }
                  showTime={false}
                  placeholder={t("ExpiryDate")}
                />
                {err("passport_expiry") && (
                  <div className="field-error">{errors.passport_expiry}</div>
                )}
              </div>
            </Col>

            {/* Phone */}
            <Col xl={4} md={6}>
              <div className="hotel-form-input-container" id="field-phone">
                <label className="hotel-form-input-label">
                  {t("ContactNumber")} ({t("Phone")}) <span>*</span>
                </label>
                <input
                  className="hotel-form-input"
                  value={form.phone}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, phone: e.target.value }))
                  }
                  placeholder={t("PhoneNumber")}
                />
                {err("phone") && (
                  <div className="field-error">{errors.phone}</div>
                )}
              </div>
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item>

      {/* 2. Flight Details */}
      <Accordion.Item eventKey="1" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          2. {t("FlightDetails")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            {/* Destination Airport */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-destination_airport"
              >
                <label className="hotel-form-input-label">
                  {t("DestinationAirport")} <span>*</span>
                </label>
                <Autocomplete
                  fullWidth
                  loading={airportLoading}
                  options={airportOptions}
                  getOptionLabel={(o) => o.airport_name || ""}
                  value={
                    airportOptions.find(
                      (o) => o.name === form.destination_airport
                    ) || null
                  }
                  inputValue={airportQuery}
                  onInputChange={(_, v) => setAirportQuery(v)}
                  onChange={(_, v) =>
                    setForm((p) => ({
                      ...p,
                      destination_airport: v?.name || "",
                      destination_airport_name: v?.airport_name || "",
                    }))
                  }
                  sx={{
                      ".MuiAutocomplete-inputRoot": {
                        fontSize: "12px",
                        flexDirection: Lang === "ar" ? "row-reverse" : "row",
                      },
                      ".MuiAutocomplete-endAdornment": {
                        left:
                          Lang === "ar" ? "9 !important" : "unset !important",
                        right:
                          Lang === "ar" ? "unset !important" : "9 !important",
                      },
                      ".MuiInputBase-input": {
                        textAlign: Lang === "ar" ? "right" : "left",
                      },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      placeholder={t("SelectAirport")}
                      InputProps={{
                          ...params.InputProps,
                          style: {
                            direction: Lang === "ar" ? "rtl" : "ltr",
                          },
                          sx: {
                            backgroundColor: "#FFF",
                            borderRadius: "6px",
                            padding: "9px 15px !important",
                            fontFamily: '"Dmsans400"',
                            fontSize: "14px !important",
                            fontWeight: 400,
                            letterSpacing: "0.25px",
                          },
                      }}
                    />
                  )}
                />
                {err("destination_airport") && (
                  <div className="field-error">
                    {errors.destination_airport}
                  </div>
                )}
              </div>
            </Col>

            {/* Departure Date */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-departure_date"
              >
                <label className="hotel-form-input-label">
                  {t("DepartureDate")} <span>*</span>
                </label>
                <SingleCalendar
                  value={form.departure_date}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, departure_date: e.value }))
                  }
                  showTime={true}
                  placeholder={t("DepartureDate")}
                  min={new Date(selectedDates.startDate)}
                  max={
                    form.return_date
                      ? new Date(
                          Math.min(
                            new Date(form.return_date).getTime(),
                            new Date(selectedDates.endDate).getTime()
                          )
                        )
                      : new Date(selectedDates.endDate)
                  }
                  viewDate={new Date(selectedDates.startDate)}
                />
                {err("departure_date") && (
                  <div className="field-error">{errors.departure_date}</div>
                )}
              </div>
            </Col>

            {/* Return Date */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-return_date"
              >
                <label className="hotel-form-input-label">
                  {t("ReturnDate")}
                </label>
                <SingleCalendar
                  value={form.return_date}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, return_date: e.value }))
                  }
                  showTime={true}
                  placeholder={t("ReturnDateOptional")}
                  min={
                    form.departure_date
                      ? new Date(
                          Math.max(
                            new Date(form.departure_date).getTime(),
                            new Date(selectedDates.startDate).getTime()
                          )
                        )
                      : new Date(selectedDates.startDate)
                  }
                  max={new Date(selectedDates.endDate)}
                  viewDate={new Date(selectedDates.endDate)}
                />
                {err("return_date") && (
                  <div className="field-error">{errors.return_date}</div>
                )}
              </div>
            </Col>

            {/* Preferred Airline */}
            <Col xl={4} md={6}>
              <div className="hotel-form-input-container">
                <label className="hotel-form-input-label">
                  {t("PreferredAirline")}
                </label>
                <Autocomplete
                  fullWidth
                  loading={airLoading}
                  options={airOptions}
                  getOptionLabel={(o) => o.airline_name || ""}
                  value={
                    airOptions.find(
                      (o) => o.airline_name === form.preferred_airline
                    ) || null
                  }
                  inputValue={airQuery}
                  onInputChange={(_, v) => setAirQuery(v)}
                  onChange={(_, v) =>
                    setForm((p) => ({
                      ...p,
                      preferred_airline: v?.airline_name || "",
                    }))
                  }
                  sx={{
                      ".MuiAutocomplete-inputRoot": {
                        fontSize: "12px",
                        flexDirection: Lang === "ar" ? "row-reverse" : "row",
                      },
                      ".MuiAutocomplete-endAdornment": {
                        left:
                          Lang === "ar" ? "9 !important" : "unset !important",
                        right:
                          Lang === "ar" ? "unset !important" : "9 !important",
                      },
                      ".MuiInputBase-input": {
                        textAlign: Lang === "ar" ? "right" : "left",
                      },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      placeholder={t("SelectAirline")}
                      InputProps={{
                          ...params.InputProps,
                          style: {
                            direction: Lang === "ar" ? "rtl" : "ltr",
                          },
                          sx: {
                            backgroundColor: "#FFF",
                            borderRadius: "6px",
                            padding: "9px 15px !important",
                            fontFamily: '"Dmsans400"',
                            fontSize: "14px !important",
                            fontWeight: 400,
                            letterSpacing: "0.25px",
                          },
                      }}
                    />
                  )}
                />
              </div>
            </Col>

            {/* Flight Class */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-flight_class"
              >
                <label className="hotel-form-input-label">
                  {t("PreferredFlightClass")} <span>*</span>
                </label>
                <Auto
                  options={flightClassOptions}
                  value={form.flight_class}
                  setValue={(v) => setForm((p) => ({ ...p, flight_class: v }))}
                />
                {err("flight_class") && (
                  <div className="field-error">{errors.flight_class}</div>
                )}
              </div>
            </Col>

            {/* Number of Passengers */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-num_passengers"
              >
                <label className="hotel-form-input-label">
                  {t("NumberOfPassengers")} <span>*</span>
                </label>
                <TravelerSelector
                  adults={adults}
                  children={children}
                  childrenAges={childrenAges}
                  infants={infants}
                  onAdultsChange={setAdults}
                  onChildrenChange={setChildren}
                  onChildrenAgesChange={setChildrenAges}
                  onInfantsChange={setInfants}
                />
              </div>
            </Col>

            {/* Flexible Dates */}
            <Col xl={12} md={12}>
              <div
                className="hotel-form-input-container"
                id="field-flexible_dates"
              >
                <label className="hotel-form-input-label">
                  {t("FlexibleTravelDates")}? <span>*</span>
                </label>
                <Form className="add-service-form-checkboxes">
                  {["1", "0"].map((v) => (
                    <Form.Check
                      key={v}
                      inline
                      type="radio"
                      label={v === "1" ? t("Yes") : t("No")}
                      name="flexible_dates"
                      value={v}
                      checked={form.flexible_dates === v}
                      onChange={() =>
                        setForm((p) => ({ ...p, flexible_dates: v }))
                      }
                      className="add-service-form-checkbox"
                    />
                  ))}
                </Form>
                {err("flexible_dates") && (
                  <div className="field-error">{errors.flexible_dates}</div>
                )}
              </div>
            </Col>

            {/* Special Requests */}
            <Col xl={12} md={12}>
              <div className="hotel-form-input-container">
                <label className="hotel-form-input-label">
                  {t("SpecialRequestHint")}
                </label>
                <textarea
                  rows={3}
                  className="hotel-form-input"
                  value={form.special_requests}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, special_requests: e.target.value }))
                  }
                  placeholder={t("EnterAnySpecialRequests")}
                />
              </div>
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item>

      {/* 3. Payment & Billing */}
      <Accordion.Item eventKey="2" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          3. {t("PaymentAndBillingInformation")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            {/* Payment Method */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-payment_method"
              >
                <label className="hotel-form-input-label">
                  {t("PaymentMethod")} <span>*</span>
                </label>
                <Auto
                  options={paymentMethodOptions}
                  value={form.payment_method}
                  setValue={(v) =>
                    setForm((p) => ({ ...p, payment_method: v }))
                  }
                />
                {err("payment_method") && (
                  <div className="field-error">{errors.payment_method}</div>
                )}
              </div>
            </Col>

            {/* Billing Address */}
            <Col xl={8} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-billing_address"
              >
                <label className="hotel-form-input-label">
                  {t("BillingAddress")} <span>*</span>
                </label>
                <input
                  className="hotel-form-input"
                  value={form.billing_address}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, billing_address: e.target.value }))
                  }
                  placeholder={t("BillingAddress")}
                />
                {err("billing_address") && (
                  <div className="field-error">{errors.billing_address}</div>
                )}
              </div>
            </Col>

            {/* Invoice required */}
            <Col xl={12}>
              <div
                className="add-service-form-checkbox-container"
                id="field-invoice_required"
              >
                <div className="add-service-form-checkbox-title">
                  {t("InvoiceRequired")}{" "}
                  <span style={{ color: "red" }}>*</span>
                </div>
                <Form className="add-service-form-checkboxes">
                  {["1", "0"].map((v) => (
                    <Form.Check
                      key={v}
                      inline
                      type="radio"
                      label={v === "1" ? t("Yes") : t("No")}
                      name="invoice"
                      value={v}
                      checked={form.invoice_required === v}
                      onChange={() =>
                        setForm((p) => ({ ...p, invoice_required: v }))
                      }
                      className="add-service-form-checkbox"
                    />
                  ))}
                </Form>
                {err("invoice_required") && (
                  <div className="field-error">{errors.invoice_required}</div>
                )}
              </div>
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item>

      {/* 4. Accommodation */}
      <Accordion.Item eventKey="3" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          4. {t("AccommodationContactDetails")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            <Col xl={12}>
              <div className="hotel-form-input-container">
                <Form.Check
                  type="checkbox"
                  label={t("HotelBooking") + "?"}
                  checked={form.hotel_booking === "1"}
                  onChange={(e) =>
                    setForm((p) => ({
                      ...p,
                      hotel_booking: e.target.checked ? "1" : "0",
                      hotel_details: e.target.checked ? p.hotel_details : "",
                    }))
                  }
                />
              </div>
            </Col>

            {form.hotel_booking === "1" && (
              <Col xl={12} style={{ marginTop: 15 }}>
                <div
                  className="hotel-form-input-container"
                  id="field-hotel_details"
                >
                  <label className="hotel-form-input-label">
                    {t("HotelDetails")} <span>*</span>
                  </label>
                  <textarea
                    rows={3}
                    className="hotel-form-input"
                    value={form.hotel_details}
                    onChange={(e) =>
                      setForm((p) => ({ ...p, hotel_details: e.target.value }))
                    }
                    placeholder={t("HotelDetailsPlaceholder")}
                  />
                  {err("hotel_details") && (
                    <div className="field-error">{errors.hotel_details}</div>
                  )}
                </div>
              </Col>
            )}
          </Row>
        </Accordion.Body>
      </Accordion.Item>

      {/* 5. Supporting Documents */}
      <Accordion.Item eventKey="4" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          5. {t("SupportingDocuments")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            {[
              { key: "passport_copy", label: t("PassportCopy"), mandatory: 1 },
              { key: "visa_copy", label: t("VisaIfRequired"), mandatory: 0 },
              {
                key: "travel_insurance",
                label: t("TravelInsuranceIfRequired"),
                mandatory: 0,
              },
              {
                key: "special_travel_permits",
                label: t("SpecialTravelPermits"),
                mandatory: 0,
              },
            ].map(({ key, label, mandatory }) => {
              const file = form?.files[key];
              const isPdf =
                file?.name?.toLowerCase().endsWith(".pdf") ||
                (typeof file === "string" &&
                  file.toLowerCase().endsWith(".pdf"));
              return (
                <Col xl={6} md={6} key={key}>
                  <div
                    className="hotel-form-input-container"
                    id={`field-file_${key}`}
                  >
                    <label className="hotel-form-input-label">
                      {label} {mandatory ? <span>*</span> : null}
                    </label>
                    <div className="custom-upload-wrapper">
                      <input
                        id={`file-${key}`}
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                        style={{ display: "none" }}
                        ref={(el) => (inputRefs.current[key] = el)}
                        onChange={(e) =>
                          handleFileChange(key, e.target.files[0])
                        }
                      />
                      {/* <label htmlFor={`file-${key}`} className="custom-upload-box">
                      {!form.files[key] ? (
                        <>
                          <span className="upload-placeholder">{t("SupportedFormats")}: JPEG, PNG, PDF</span>
                          <UploadIcon className="upload-svg-icon" />
                        </>
                      ) : (
                        <>
                          <span className="upload-filename">
                            {truncate(fileDisplayName(form.files[key]))}
                          </span>
                          <span
                            className="upload-remove"
                            onClick={(e) => {
                              e.preventDefault();
                              handleFileRemove(key);
                            }}
                          >
                            ×
                          </span>
                        </>
                      )}
                    </label> */}

                      {file ? (
                        <div className="custom-upload-box">
                          <div className="file-info">
                            {isPdf ? (
                              <a
                                href={
                                  typeof file === "string"
                                    ? `${url}${file}`
                                    : URL.createObjectURL(file)
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                className="file-link"
                              >
                                {truncate(fileDisplayName(file))}
                                <span className="file-type-badge">PDF</span>
                              </a>
                            ) : (
                              <span className="file-name">
                                {truncate(fileDisplayName(file))}
                              </span>
                            )}
                          </div>

                          <div className="file-actions">
                            <button
                              type="button"
                              className="file-action-btn view-file-btn"
                              onClick={() => {
                                if (isPdf) {
                                  window.open(
                                    typeof file === "string"
                                      ? `${url}${file}`
                                      : URL.createObjectURL(file),
                                    "_blank"
                                  );
                                } else {
                                  const imageUrl =
                                    typeof file === "string"
                                      ? `${url}${file}`
                                      : URL.createObjectURL(file);
                                  setPreviewImage(imageUrl);
                                  setShowModal(true);
                                }
                              }}
                            >
                              {isPdf ? t("View") : t("Preview")}
                            </button>

                            <button
                              type="button"
                              className="file-action-btn remove-file-btn"
                              onClick={(e) => {
                                e.preventDefault();
                                handleFileRemove(key);
                              }}
                            >
                              {t("Remove")}
                            </button>
                          </div>
                        </div>
                      ) : (
                        <label
                          htmlFor={`file-${key}`}
                          className="custom-upload-box"
                        >
                          <span className="upload-placeholder">
                            {t("Supported")}: {t("Jpeg")}, {t("Png")},{" "}
                            {t("Pdf")}
                          </span>
                          <UploadIcon className="upload-svg-icon" />
                        </label>
                      )}
                    </div>
                    {err(`file_${key}`) && (
                      <div className="field-error" style={{ marginTop: 5 }}>
                        {errors[`file_${key}`]}
                      </div>
                    )}
                  </div>
                </Col>
              );
            })}
          </Row>
        </Accordion.Body>
      </Accordion.Item>

      {/* 6. Declaration */}
      <Accordion.Item eventKey="5" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          6. {t("DeclarationAndSignature")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            {/* Terms */}
            <Col xl={12}>
              <div
                className="hotel-form-input-container"
                id="field-agree_terms"
              >
                <Form.Check
                  type="checkbox"
                  label={t("agreeHint")}
                  checked={form.agree_terms}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, agree_terms: e.target.checked }))
                  }
                />
                {err("agree_terms") && (
                  <div className="field-error">{errors.agree_terms}</div>
                )}
              </div>
            </Col>

            {/* Signature */}
            <Col xl={6}>
              <div className="hotel-form-input-container" id="field-signature">
                <label className="hotel-form-input-label">
                  {t("Signature")} <span>*</span>
                </label>
                <div
                  className="signature-container"
                  style={{ position: "relative" }}
                >
                  <SignatureCanvas
                    ref={sigPadRef}
                    penColor="black"
                    canvasProps={{
                      width: 500,
                      height: 150,
                      className: "sigCanvas",
                    }}
                    onEnd={() =>
                      setForm((p) => ({
                        ...p,
                        signature: sigPadRef.current.toDataURL(),
                      }))
                    }
                  />
                  <button
                    type="button"
                    title={t("Clear")}
                    onClick={() => {
                      sigPadRef.current.clear();
                      setForm((p) => ({ ...p, signature: "" }));
                    }}
                    className="signature-clear-btn"
                  >
                    ⟳
                  </button>
                </div>
                {err("signature") && (
                  <div className="field-error">{errors.signature}</div>
                )}
              </div>
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item>
      {previewImage && (
        <div
          className={`modal fade ${
            showModal ? "show d-block" : ""
          } service-files-modal`}
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={() => setShowModal(false)}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                onClick={() => setShowModal(false)}
              ></button>
              <div className="service-image-file">
                <img
                  // src={initialData ? `${url}${previewImage}` : previewImage}
                  src={previewImage}
                  alt="preview"
                  style={{ maxWidth: "100%" }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </Accordion>
  );
});

export default FlightsForm;